const filterForm = document.getElementById('filter-form');

if (filterForm) {
  const searchParams = new URLSearchParams(window.location.search);

  if (searchParams.toString() !== '') {
    const masthead = document.getElementById('masthead');
    const mastheadHeight = masthead.getBoundingClientRect().height;
    const filterFormTop = filterForm.getBoundingClientRect().top;
    const scrollPos = filterFormTop - mastheadHeight - 40;

    window.scrollTo({ top: scrollPos, behavior: 'smooth' });
  }
}
